import { createContext, useContext } from "react"

const CurrentDashboardIdContext = createContext<string | null>(null)

export const CurrentDashboardIdProvider = CurrentDashboardIdContext.Provider

export function useCurrentDashboardId(): string | null {
  return useContext(CurrentDashboardIdContext)
}
